import { onMounted, onUnmounted } from 'vue';

const sharedChannel = new BroadcastChannel('zs:shared');
// oxlint-disable-next-line no-explicit-any
const listeners = new Map<string, Set<(data: any) => void>>();
sharedChannel.addEventListener('message', (event: MessageEvent) => {
    if (event.origin !== location.origin) return;
    if (typeof event.data !== 'object') return;
    for (const k in event.data) {
        if (k.startsWith('zs:')) {
            listeners.get(k.slice(3))?.forEach(cb => cb(event.data[k]));
        }
    }
});

// eslint-disable-next-line no-explicit-any
export function broadcastMessage<T>(channel: string, message: T) {
    sharedChannel.postMessage({ [`zs:${channel}`]: message });
}

export function addBroadcastMessageListener<T>(channel: string, callback: (data: T) => void) {
    const eventListener = listeners.get(channel) || new Set();
    eventListener.add(callback);
    listeners.set(channel, eventListener);
}

export function removeBroadcastMessageListener<T>(channel: string, callback: (data: T) => void) {
    listeners.get(channel)?.delete(callback);
}

export function useBroadcastMessageMonitor<T>(name: string) {
    // eslint-disable-next-line no-explicit-any
    let pendingPromiseResolver: ((value: any) => void) | null = null;

    const handleMessage = (data: T) => {
        pendingPromiseResolver?.(data);
        pendingPromiseResolver = null;
    };

    onMounted(() => addBroadcastMessageListener<T>(name, handleMessage));
    onUnmounted(() => removeBroadcastMessageListener<T>(name, handleMessage));

    return {
        waitForMessage: <T>() =>
            new Promise<T>(resolve => {
                pendingPromiseResolver = resolve;
            })
    };
}

export function onBroadcastMessage<T>(name: string, callback: (data: T) => void) {
    onMounted(() => addBroadcastMessageListener<T>(name, callback));
    onUnmounted(() => removeBroadcastMessageListener<T>(name, callback));
}
